import { render, staticRenderFns } from "./feedbacks.vue?vue&type=template&id=acb2a74a&scoped=true&"
import script from "./feedbacks.vue?vue&type=script&lang=js&"
export * from "./feedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb2a74a",
  null
  
)

export default component.exports